import app from 'flarum/forum/app';
import TextEditor from 'flarum/common/components/TextEditor';
import CommentPost from 'flarum/forum/components/CommentPost';
import { extend } from 'flarum/common/extend';
import LineupModal from './LineupModal';
import Lineup from './Lineup';
import Squad from './Squad';
export default function extendLineupRenderer(app) {
  extend(TextEditor.prototype, 'toolbarItems', function (items) {
    items.add('lineup', m('button', {
      className: 'Button Button--icon Button--link hasIcon',
      title: app.translator.trans('bizkaitarra-lineup.forum.composer.lineup_tooltip'),
      onclick: () => {
        app.modal.show(LineupModal, {
          onsubmit: lineup => {
            this.attrs.composer.editor.insertAtCursor(lineup);
          }
        });
      }
    }, m('i', {
      className: 'fas fa-futbol'
    })));
  });
  const renderLineups = postElement => {
    postElement.querySelectorAll('.football-lineup').forEach(el => {
      const formation = el.getAttribute('data-formation');
      const kit = el.getAttribute('data-kit');
      const players = el.getAttribute('data-players');

      // Check if already rendered with SAME data
      if (el.hasAttribute('data-rendered')) {
        const lastFormation = el.getAttribute('data-last-formation');
        const lastKit = el.getAttribute('data-last-kit');
        const lastPlayers = el.getAttribute('data-last-players');
        if (lastFormation === formation && lastKit === kit && lastPlayers === players) {
          return;
        }

        // Clean up if data changed
        m.mount(el, null);
      }

      // Only mount if players exist to avoid crashes
      if (players) {
        try {
          // Mount the component
          m.mount(el, {
            view: () => m(Lineup, {
              formation,
              kit,
              players
            })
          });
          el.setAttribute('data-rendered', 'true');
          el.setAttribute('data-last-formation', formation || '');
          el.setAttribute('data-last-kit', kit || '');
          el.setAttribute('data-last-players', players || '');
        } catch (e) {
          console.error('Error mounting lineup:', e);
        }
      }
    });
  };
  const renderSquads = postElement => {
    postElement.querySelectorAll('.football-squad').forEach(el => {
      const data = el.getAttribute('data-data');

      // Check if already rendered with SAME data
      if (el.hasAttribute('data-rendered')) {
        const lastData = el.getAttribute('data-last-data');
        if (lastData === data) {
          return;
        }

        // Clean up if data changed
        m.mount(el, null);
      }
      if (data) {
        try {
          // Mount the component
          m.mount(el, {
            view: () => m(Squad, {
              data
            })
          });
          el.setAttribute('data-rendered', 'true');
          el.setAttribute('data-last-data', data || '');
        } catch (e) {
          console.error('Error mounting squad:', e);
        }
      }
    });
  };
  const cleanCodeBlocks = postElement => {
    if (!postElement) return;

    // Clean <pre> elements that contain a <code> tag (block code blocks)
    postElement.querySelectorAll('pre').forEach(preEl => {
      const codeEl = preEl.querySelector('code');
      const text = codeEl ? codeEl.textContent : preEl.textContent;
      const newEl = document.createElement('span');
      newEl.style.whiteSpace = 'pre-wrap';
      newEl.style.fontFamily = 'inherit';
      newEl.style.fontSize = 'inherit';
      newEl.style.backgroundColor = 'transparent';
      newEl.style.padding = '0';
      newEl.style.border = 'none';
      newEl.style.color = 'inherit';
      newEl.textContent = text;
      if (preEl.parentNode) {
        preEl.parentNode.replaceChild(newEl, preEl);
      }
    });

    // Clean any remaining <code> elements (e.g. inline code blocks)
    postElement.querySelectorAll('code').forEach(codeEl => {
      const text = codeEl.textContent;
      const newEl = document.createTextNode(text);
      if (codeEl.parentNode) {
        codeEl.parentNode.replaceChild(newEl, codeEl);
      }
    });
  };
  extend(CommentPost.prototype, 'oncreate', function () {
    cleanCodeBlocks(this.element);
    renderLineups(this.element);
    renderSquads(this.element);
  });
  extend(CommentPost.prototype, 'onupdate', function () {
    // Use setTimeout to defer rendering to the next tick to avoid redraw conflicts
    // and ensure Flarum has finished DOM updates.
    setTimeout(() => {
      if (this.element) {
        cleanCodeBlocks(this.element);
        renderLineups(this.element);
        renderSquads(this.element);
      }
    }, 0);
  });
}
flarum.reg.add('nagusi-match-ratings', 'forum/lineup/extendLineupRenderer', extendLineupRenderer);